import { InputCheckboxSm, InputSwitchSemFormik, InputDatePicker, TextArea, InputPadrao } from '../../../../components/Inputs'
import { InputGuiaStatusParticular, InputEstabelecimentoSaude, InputTipoExecutante, InputSocio, InputStatusEnvio } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect, useRef } from 'react'
import Yup, { validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form, FieldArray } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, validar } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'
import { ModalCadastro, ModalDuasOpcoes } from '../../../../components/Modais'
import { OverlayTrigger, Overlay, Tooltip } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi'
import { incluirGuiaTelaManutencao, filtragemTelaManutencao, incluirGuiaBdManutencao, obterGuiasManutencao, obterGuiasManutencaoEspecificas } from '../../../../util/FuncoesComuns'
import { InputMovimentoFinanceiro } from '../../../../components/InputsAutoCompleteV2'

export default props => {
    let { id } = useParams()
    const [abrirModal, setAbrirModal] = useState(true)
    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({ modalAberto: false, filtros: { estabelecimento_saude: '' } })
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [guias, setGuias] = useState([])
    const [carregando, setCarregando] = useState(false);
    const refGuias = useRef(null)
    const [totalSelecionados, setTotalSelecionados] = useState(0)
    const [podeEnviarForm, setPodeEnviarForm] = useState(false);

    const [validacao] = useState(Yup.lazy(({ filtros, modalAberto }) => Yup.object({
        status: Yup.string().nullable().required(),
    }).shape({
        guias: Yup.array()
            .test('Guias', 'Selecione ao menos uma Guia', function (value) {
                return this.parent.guias && this.parent.guias.length
            }),
        filtros: Yup.object().shape({
            data_inicial_procedimento: Yup.string().nullable()
                .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial_procedimento) }),
            // .test('Data Inicial', 'Campo Obrigatório!', function (value) { return modalAberto ? (this.parent.data_inicial_procedimento || filtros.estabelecimento_saude) : true }),
            data_final_procedimento: Yup.string().nullable()
                .test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final_procedimento) }),
            // .test('Data Final', 'Campo Obrigatório!', function (value) { return modalAberto ? (this.parent.data_final_procedimento || filtros.estabelecimento_saude) : true }),
            data_inicial_registro: Yup.string().nullable()
                .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial_registro) }),
            data_final_registro: Yup.string().nullable()
                .test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final_registro) }),
        })
    })))

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        let cloneValues = { ...values }
        delete cloneValues.filtros

        cloneValues.guias = cloneValues.guias.map(item => item.id)

        salvar(
            { id: cloneValues.guias.join(','), ...cloneValues },
            '/faturamento/guiaparticularalterarstatusmultiplo',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    setSalvando(false)
                }
                else
                    props.history.push('/faturamento/guia-particular/consulta')
            },
            (err) => setSalvando(false))
    }

    useEffect(_ => {
        setValoresIniciais({
            status: "",
            guias: [],
            modalAberto: false,
            filtros: { estabelecimento_saude: '' }
        })
    }, [])

    const funcaoAposSim = (formik) => {
        setShowModalValidacao(false)
        Submit(formik.values, formik)
    }

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Faturamento</span>,
        () => <Link className='link-active' to={'/faturamento/guia-particular/consulta'}>Status</Link>,
    ]

    const validarSubmit = async (values, propsFormik) => {
        setSalvando(true)

        let cloneValues = { ...values }
        delete cloneValues.filtros

        cloneValues.guias = cloneValues.guias.map(item => item.id)

        await validar(`/faturamento/validarStatusMultiplo`, cloneValues, (e) => Submit(values, propsFormik), (e) => {
            setMensagemModal(<>{e.response.data.alertas.map(x => x.indexOf('*') > -1 ? <>{x.replace('*', '')}<br /></> : <div className='mb-1'><b>{x}<br /></b></div>)}</>)
            setShowModalValidacao(true)
            setSalvando(false)
        })
    }

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => { if (podeEnviarForm) { validarSubmit(values, propsFormik) } }}>
            {propsFormik => {
                return (<><Form>
                    {!props.modal && <HeaderCadastro titulo={"Manutenção de Status Guia Particular"} link={links} />}
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputGuiaStatusParticular label="Status" name="status" placeholder="Status" propsFormik={propsFormik} tamanho={'col-lg-3'} obrigatorio={true} />
                                <TextArea label='Justificativa' name='justificativa' type='text' placeholder='Justificativa' tamanho={'col-xl-9 col-sm-12'} classeTooltip={'tooltip-input-modal'} />
                            </div>
                        </div>
                    </div>
                    <div className="mt-30">
                        <HeaderCadastro
                            titulo={'Guias'}
                            classeChildren='space-between-100' >
                        </HeaderCadastro>
                    </div>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='col-12'>
                                <div className='row'>
                                    <div className='col-8 row'>
                                        <InputPadrao
                                            disabled={carregando}
                                            tamanho="col-3"
                                            name="codigo_id"
                                            id="codigo_id"
                                            type="number"
                                            placeholder="Código"
                                            onBlur={(e) => {
                                                setPodeEnviarForm(true)
                                                setCarregando(true)
                                                if (e.target.value && e.target.value.length > 0)
                                                    obterGuiasManutencaoEspecificas({ codigo: e.target.value }, val => {
                                                        setGuias([...(val.filter(x => !guias.find(y => y.id === x.id))).map(x => ({ especifica: true, ...x })), ...guias])
                                                        setCarregando(false)
                                                        propsFormik.setFieldValue("codigo_id", '')
                                                    }, true)
                                                else
                                                    setCarregando(false)
                                            }}
                                            onKeyUp={(e) => {
                                                e.preventDefault()
                                                setPodeEnviarForm(false)
                                                if (e.keyCode === 13) {
                                                    setCarregando(true)
                                                    if (e.target.value && e.target.value.length > 0)
                                                        obterGuiasManutencaoEspecificas({ codigo: e.target.value }, val => {
                                                            setGuias([...(val.filter(x => !guias.find(y => y.id === x.id))).map(x => ({ especifica: true, ...x })), ...guias])
                                                            setCarregando(false)
                                                            propsFormik.setFieldValue("codigo_id", '')
                                                            document.getElementById('codigo_id').focus();

                                                        }, true)
                                                        
                                                    else
                                                        setCarregando(false)
                                                }
                                            }}

                                        />

                                        <span style={{ marginTop: 15 }}>{`Guia(s) Selecionada(s): `} <b>{totalSelecionados}</b></span>

                                        {carregando && <span className="spinner-border spinner-border-md" role="status" aria-hidden="true" style={{ opacity: 0.2 }}></span>}
                                    </div>
                                    <div className='col-4 text-right'>
                                        <BotaoPadrao texto='Limpar' type={'button'} click={_ => {
                                            setGuias([]);
                                            document.getElementById('codigo_id').focus();
                                        }}
                                            idTooltip={'Filtros'}
                                        />

                                        <BotaoPadrao texto='Filtros' type={'button'} click={_ => propsFormik.setFieldValue('modalAberto', true)} idTooltip={'Filtros'} /></div>
                                </div>
                                <div className="custom-scrollbar" style={{ maxHeight: 800 }} ref={refGuias}>
                                    {/* <p>Testando</p>
                                        <p><i>Escrito por: Marcelo Hugo de Almeida</i></p> */}
                                    <table className='table tabela-porte-acomodacao table-responsive-md table-striped tabela' >
                                        <thead>
                                            {
                                                <tr>
                                                    <th className='text-center' style={{ width: '2%' }}>
                                                        <InputSwitchSemFormik onClick={(e) => {
                                                            if (guias.length) {
                                                                const guiasSelecionadas = [...propsFormik.values['guias']].concat([...guias])
                                                                propsFormik.setFieldValue('guias', guiasSelecionadas)
                                                                setGuias([])
                                                                setTotalSelecionados(guiasSelecionadas.length)
                                                            } else {
                                                                propsFormik.setFieldValue('guias', [])
                                                                setTotalSelecionados(0)
                                                                setGuias(filtragemTelaManutencao(propsFormik.values.filtros, propsFormik.values['guias']))
                                                            }
                                                        }} checked={propsFormik.values && propsFormik.values.guias && propsFormik.values.guias.length && !guias.length} classeDiv='form-group' name='plantao' size="md" tamanho='a' classeTooltip={'tooltip-input-modal'} />
                                                    </th>
                                                    <th style={{ width: '2%' }}>Cód.</th>
                                                    <th style={{ width: '4%' }}>Guia</th>
                                                    <th style={{ width: '27%' }}>Paciente</th>
                                                    <th style={{ width: '27%' }}>Estab. de Saúde</th>
                                                    <th style={{ width: '9%' }}>Data Proced.</th>
                                                    <th style={{ width: '9%' }}>Hora Proced.</th>
                                                    <th style={{ width: '12%' }}>Status</th>
                                                    <th style={{ width: '10%' }}>Data Registro</th>
                                                </tr>
                                            }
                                        </thead>
                                        <tbody>
                                            <FieldArray name="guias">
                                                {(arrayHelpers => (
                                                    guias.length || propsFormik.values.guias && propsFormik.values.guias.length ?
                                                        <>{propsFormik.values && propsFormik.values.guias && propsFormik.values.guias.length && propsFormik.values.guias.map((item, index) =>
                                                            <tr>
                                                                <>
                                                                    <td className='text-center'>
                                                                        <InputCheckboxSm name={`guias[${index}].guia_checked`} checked={true} onChange={_ => { incluirGuiaBdManutencao(propsFormik, item, guias, setGuias, setTotalSelecionados) }} /></td>
                                                                    <td>{item.id}</td>
                                                                    <td>{item.guia_principal}</td>
                                                                    <td>{item.nome_beneficiario}</td>
                                                                    <td>{item.estabelecimento_saude}</td>
                                                                    <td>{item.data_procedimento}</td>
                                                                    <td>{item.hora_procedimento}</td>
                                                                    <td><span className='guia-status' style={{ background: item.cor_status }}>{item.status}</span></td>
                                                                    <td>{item.data_insercao}</td>
                                                                </>
                                                            </tr>) || <></>}
                                                            {guias.length && guias.map((item, index) =>
                                                                <tr>
                                                                    <>
                                                                        <td className='text-center'>
                                                                            <InputCheckboxSm name={`guias[${index}].guia_checked`} checked={false} onChange={_ => { incluirGuiaTelaManutencao(propsFormik, item, guias, setGuias, setTotalSelecionados) }} />
                                                                        </td>
                                                                        <td>{item.id}</td>
                                                                        <td>{item.guia_principal}</td>
                                                                        <td>{item.nome_beneficiario}</td>
                                                                        <td>{item.estabelecimento_saude}</td>
                                                                        <td>{item.data_procedimento}</td>
                                                                        <td>{item.hora_procedimento}</td>
                                                                        <td><span className='guia-status' style={{ background: item.cor_status }}>{item.status}</span></td>
                                                                        <td>{item.data_insercao}</td>
                                                                    </>
                                                                </tr>
                                                            ) || <></>}</> : <tr><td colSpan={12} className="text-center"><div className='mt-2'><span>{propsFormik.values && propsFormik.values.filtros && (propsFormik.values.filtros.data_inicial_procedimento || propsFormik.values.filtros.data_final_procedimento) ? 'Sem Registros' : 'Utilize filtros para buscar guias'}</span></div></td></tr>
                                                ))}
                                            </FieldArray>
                                            {propsFormik.touched.guias && propsFormik.errors.guias && !Array.isArray(propsFormik.errors.guias) ?
                                                <Overlay target={refGuias.current} show={true} placement="bottom">
                                                    {props2 => {
                                                        return (
                                                            <Tooltip id={Math.random()} className={"error-tooltip tooltip-input-modal"} {...props2}>
                                                                <div className="error">
                                                                    <FiAlertTriangle className="icone" /> <span>{propsFormik.errors.guias}</span></div>
                                                            </Tooltip>)
                                                    }}
                                                </Overlay> : <></>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                        </div>
                    </div>

                    {!props.modal && <div className='separator mt-40 mb-5'></div>}
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    </div>
                    <ModalCadastro titulo={'Filtros'} show={propsFormik.values.modalAberto} setShowModal={(val) => propsFormik.setFieldValue('modalAberto', val)} >
                        <div className='row'>
                            <InputEstabelecimentoSaude multiplo={true} placeholder="Estabelecimento de Saúde" label="Estabelecimento de Saúde" name="filtros.estabelecimento_saude" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} onChange={(e) => {
                                propsFormik.setFieldValue('filtros.estabelecimento_saude', e);
                            }} />
                            <InputGuiaStatusParticular multiplo={true} placeholder="Status" label="Status" name="filtros.status" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} onChange={(e) => {
                                propsFormik.setFieldValue('filtros.status', e);
                            }} />
                            <InputSocio multiplo={true} placeholder="Sócio Equipe" label="Sócio Equipe" name="filtros.socio_equipe" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} onChange={(e) => {
                                propsFormik.setFieldValue('filtros.socio_equipe', e);
                            }} />

                            <InputMovimentoFinanceiro multiplo={true} placeholder="Movimento Financeiro" label="Movimento Financeiro" name="filtros.movimento_financeiro" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} onChange={(e) => {
                                propsFormik.setFieldValue('filtros.movimento_financeiro', e);
                            }} />

                            <InputDatePicker
                                label="Data Inicial Procedimento"
                                name="filtros.data_inicial_procedimento"
                                classeTooltip={'tooltip-input-modal'}
                                // obrigatorio={!(propsFormik.values.filtros && propsFormik.values.filtros.estabelecimento_saude)}
                                type="text"
                                setarValor={value => {
                                    propsFormik.setFieldValue("filtros.data_inicial_procedimento", value)
                                }}
                                onChange={value => {
                                    propsFormik.setFieldValue("filtros.data_inicial_procedimento", value)
                                }}
                                placeholder="Data Inicial Procedimento"
                            />

                            <InputDatePicker
                                label="Data Final Procedimento"
                                name="filtros.data_final_procedimento"
                                type="text"
                                // obrigatorio={!(propsFormik.values.filtros && propsFormik.values.filtros.estabelecimento_saude)}
                                classeTooltip={'tooltip-input-modal'}
                                setarValor={value => {
                                    propsFormik.setFieldValue("filtros.data_final_procedimento", value)
                                }}
                                onChange={value => {
                                    propsFormik.setFieldValue("filtros.data_final_procedimento", value)
                                }}
                                placeholder="Data Final Procedimento"
                            />

                            <InputDatePicker
                                label="Data Inicial Registro"
                                name="filtros.data_inicial_registro"
                                type="text"
                                classeTooltip={'tooltip-input-modal'}
                                setarValor={value => {
                                    propsFormik.setFieldValue("filtros.data_inicial_registro", value)
                                }}
                                onChange={value => {
                                    propsFormik.setFieldValue("filtros.data_inicial_registro", value)
                                }}
                                placeholder="Data Inicial Registro"
                            />

                            <InputDatePicker
                                label="Data Final Registro"
                                name="filtros.data_final_registro"
                                type="text"
                                classeTooltip={'tooltip-input-modal'}
                                setarValor={value => {
                                    propsFormik.setFieldValue("filtros.data_final_registro", value)
                                }}
                                onChange={value => {
                                    propsFormik.setFieldValue("filtros.data_final_registro", value)
                                }}
                                placeholder="Data Final Registro"
                            />
                        </div>
                        <div className='direita container-botoes mb-3 group-salvar-novo'>
                            <BotaoPadrao texto='Filtrar' disabled={false} type="button" click={() => {
                                obterGuiasManutencao(propsFormik, (val) => { setGuias([...(guias.filter(x => x.especifica)), ...(val.filter(x => !(guias.findIndex(y => y.id === x.id) > -1)))]) }, true)
                            }} />
                        </div>
                    </ModalCadastro>
                </Form>
                    <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => funcaoAposSim(propsFormik)} funcaoOpcao1={() => { setSalvando(false); setShowModalValidacao(false) }}
                        esconderFechar mensagem={<>{<>{'Validações:'} <br /><br /></>} {mensagemModal}<br />
                            {'Deseja Continuar?'}</>}
                        textoOpcao1={'Cancelar'}
                        classeOpcao1={'btn-sm btn-primary-modal simples'}
                        textoOpcao2={'Continuar'} /></>)
            }}
        </Formik>
    )
}